import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

import { store } from '@/Infrastructure/State';
import type { CartPayments } from '@/modules/cart/domain/CartPayments';
import type { CartPaymentsRepository } from '@/modules/cart/domain/CartPaymentsRepository';
import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';
import type { TErrorResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

const { CART_URL } = environment;

const isWedding = isWeddingFlow();

const get = async (): Promise<CartPayments> => {
  if (isWedding) return {} as CartPayments;

  return (await httpClient.get(`${CART_URL}/active-cart/alternative-payments`))
    .data;
};

export const createCartPaymentsRepository = (): CartPaymentsRepository => ({
  get: async () => {
    const { payload } = await store.dispatch(getCartPayments());
    return payload as CartPayments;
  }
});

export const getCartPayments = createAsyncThunk<
  CartPayments,
  void,
  { rejectValue: TErrorResponse }
>('cartPayments', async (_, { rejectWithValue }) => {
  try {
    const cart = await get();
    return cart;
  } catch (error) {
    const errorInfo = (error as AxiosError)?.response?.data as TErrorResponse;

    return rejectWithValue(errorInfo);
  }
});
